import React, { useState, useContext, useEffect } from "react"

import { navigate } from "gatsby"

import { GlobalAuthContext } from "../../context/authContext"

import { SIDEBAR_MENU_STEP } from "../../constants/sidebar-menu"
import { CANDIDATE_STEP_MENU } from "../../constants/profile-menu"

import { GET_CONFIG_DATA } from "../../components/shared-actions/get-config-data"
import { CANDIDATE_PROFESSIONAL_DATA_FETCH } from "../../components/candidate-profile/actions/professionalAction"

import ModalComponent from "../../components/modal/modal"
import CandidateProfileLayout from "../../components/layout/candidate-profile"
import PortfolioInputForm from "../../components/candidate-profile/form/portfolio-input"
import DeleteConfirmForm from "../../components/candidate-profile/form/delete-confirm"
import ProfessionalForm from "../../components/candidate-profile/form/professional-form"
import PastExpInputForm from "../../components/candidate-profile/form/past-experience-input"

const ProfessionalPage = ({ location }) => {
  const [images, setImages] = useState([])

  const [configData, setConfigData] = useState({})

  const [pastExp, setPastExp] = useState()

  const [experiences, setExperience] = useState([])

  const [formState, setFormState] = useState({
    position: "",
    industry: "",
    status: "",
    salary: "",
    job_type_id: "",
    job_shift_id: "",
    skills: [],
    industry_skills: [],
  })

  const [country, setCountry] = useState(1)

  const [addPastExp, setAddPastExp] = useState(false)
  const [addPortfolio, setAddPortfolio] = useState(false)
  const [showDeleteForm, setShowDeleteForm] = useState(false)

  const [portfolioFormData, setPortFolioFormData] = useState({
    title: "",
    imageUrl: "",
    url: "",
    description: "",
  })

  const [experienceFormData, setExperienceFormData] = useState({
    companyName: "",
    email: "",
    phone: "",
    position: "",
    to: "",
    from: "",
    running: false,
    about: "",
  })

  const [uploadedImage, setUploadedImage] = useState()

  const handlePortfolioModalHide = (value, id) => {
    if (id !== undefined) {
      setAddPortfolio(value)
      const image = images.filter(image => image.id === id)
      setPortFolioFormData({
        ...portfolioFormData,
        title: image[0].title,
        imageUrl: image[0].image,
        url: image[0].project_url,
        description: image[0].description,
        id: id,
        type: "PATCH",
      })
    } else {
      setAddPortfolio(value)
      setUploadedImage()
      setPortFolioFormData({
        title: "",
        imageUrl: "",
        url: "",
        description: "",
      })
    }
  }

  const { state, dispatch } = useContext(GlobalAuthContext)

  const handlePastExpModelHide = (value, id) => {
    if (id !== undefined) {
      setAddPastExp(value)
      const pastExp = experiences.filter(exp => exp.id === id)
      setExperienceFormData({
        ...experienceFormData,
        position: pastExp[0].position,
        companyName: pastExp[0].company,
        email: pastExp[0].email,
        phone: pastExp[0].phone,
        description: pastExp[0].description,
        from: new Date(pastExp[0].started_on),
        to:
          pastExp[0].ended_on === "Current"
            ? null
            : new Date(pastExp[0].ended_on),
        running: pastExp[0].ended_on === "Current",
        type: "PATCH",
        id: id,
      })
    } else {
      setAddPastExp(value)
      setExperienceFormData({
        companyName: "",
        email: "",
        phone: "",
        position: "",
        description: "",
      })
    }
  }

  const [id, setID] = useState(null)
  const [type, setType] = useState(null)

  const handleDeleteConfirmModalHide = (value, itemId, deleteType) => {
    setShowDeleteForm(value)
    if (itemId && deleteType) {
      setID(itemId)
      setType(deleteType)
    } else {
      setShowDeleteForm(false)
      setID(null)
    }
  }

  const [isLoading, setLoading] = useState(true)

  useEffect(
    () => {
      const fetchData = async () => {
        try {
          const id = JSON.parse(localStorage.getItem("user")).id
          if (state && state.user && state.user.role === 2) {
            await CANDIDATE_PROFESSIONAL_DATA_FETCH(
              id,
              dispatch,
              setFormState,
              setImages,
              setExperience,
              setCountry
            )
            setLoading(false);
          }
          if (!state.config) {
            await GET_CONFIG_DATA(setConfigData, dispatch)
          } else {
            setConfigData(state.config)
          }
        } catch (err) {
          dispatch({ type: "LOGOUT" })
          navigate("/login")
        }
      }
      fetchData();
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    [
      dispatch,
      state.config,
      showDeleteForm,
      addPastExp,
      addPortfolio,
      state.isAuthenticated,
    ]
  )

  return (
    <CandidateProfileLayout
      menu={CANDIDATE_STEP_MENU}
      sidebarMenu={SIDEBAR_MENU_STEP}
      activeSidebar="Edit Profile"
      active="Professional"
      title="Professional"
      location={location}
    >
      <ModalComponent
        onHide={() => handlePortfolioModalHide}
        setShow={handlePortfolioModalHide}
        show={addPortfolio}
      >
        <PortfolioInputForm
          portfolioFormData={portfolioFormData}
          setPortFolioFormData={setPortFolioFormData}
          uploadedImage={uploadedImage}
          addPastExp={addPastExp}
          addPortfolio={addPortfolio}
          setUploadedImage={setUploadedImage}
          setAddPortfolio={setAddPortfolio}
        />
      </ModalComponent>
      <ModalComponent
        onHide={() => handleDeleteConfirmModalHide}
        setShow={handleDeleteConfirmModalHide}
        show={showDeleteForm}
      >
        <DeleteConfirmForm
          id={id}
          type={type}
          isCompany={false}
          setShowDeleteForm={setShowDeleteForm}
        />
      </ModalComponent>
      <ModalComponent
        onHide={handlePastExpModelHide}
        setShow={setAddPastExp}
        show={addPastExp}
      >
        <PastExpInputForm
          experienceFormData={experienceFormData}
          setExperienceFormData={setExperienceFormData}
          setAddPastExp={setAddPastExp}
        />
      </ModalComponent>
      <ProfessionalForm
        setAddPortfolio={handlePortfolioModalHide}
        setAddPastExp={handlePastExpModelHide}
        configData={configData}
        formState={formState}
        setFormState={setFormState}
        experiences={experiences}
        setExperience={setExperience}
        isLoading={isLoading}
        pastExp={pastExp}
        setPastExp={setPastExp}
        images={images}
        setImages={setImages}
        country={country}
        setShowDeleteForm={handleDeleteConfirmModalHide}
      />
    </CandidateProfileLayout>
  )
}

export default ProfessionalPage
